export const ProfileForm = ({ profile, setProfile, busy, onSave }) => (
  <form onSubmit={onSave} className="bg-white border border-[#e2ebe4] rounded-lg p-6 max-w-lg space-y-4" data-testid="profile-form">
    <div>
      <label className="field-label">Full name</label>
      <input className="field-input" value={profile.name} onChange={(e) => setProfile({ ...profile, name: e.target.value })} data-testid="profile-name-input" />
    </div>
    <div>
      <label className="field-label">Phone</label>
      <input className="field-input" value={profile.phone} onChange={(e) => setProfile({ ...profile, phone: e.target.value })} data-testid="profile-phone-input" />
    </div>
    <div>
      <label className="field-label">Driving license no.</label>
      <input className="field-input" value={profile.license_no} onChange={(e) => setProfile({ ...profile, license_no: e.target.value })} data-testid="profile-license-input" />
    </div>
    <div>
      <label className="field-label">Nationality</label>
      <input className="field-input" value={profile.nationality} onChange={(e) => setProfile({ ...profile, nationality: e.target.value })} data-testid="profile-nationality-input" />
    </div>
    <button type="submit" disabled={busy} className="btn-cta rounded px-6 py-3 text-xs" data-testid="profile-save-btn">Save changes</button>
  </form>
);
